<!--
  Specialization of ElColorableInput for response
-->

<script>
import ElColorableInput from './ElColorableInput.vue'
import ElColorableAutocomplete from './ElColorableAutocomplete.vue'

const ElStringInput = {
  name: 'ElStringInput',
  extends: ElColorableInput,

  data () {
    return {
      suggestion: null,
    }
  },
  watch: {
    suggestion (val) {
      this.$emit('suggestion', val)
    },
    position () {
      // saves a suggestion for later, if the user presses "down"
      this.handleSuggestion(false)
    },
  },

  mounted () {
    // display suggestion if the user it typing a variable
    this.$on('userupdate', () => {
      this.handleSuggestion(true)
    })
  },

  methods: {
    // parses $ and @ variables
    fromExpression (expression) {
      const segs = []
      expression.replace(/([^$@]+)|(\$\$|@@)|([$@])(?:(\{)([A-Za-z_][A-Za-z_0-9]*)?(\})?|([A-Za-z_][A-Za-z_0-9]*)?)/g,
        (_, text, escape, prefix, enclosed_begin, enclosed_name, enclosed_end, name) => {
          if (text) {
            segs.push({
              type: 'text',
              text: text,
              key: Math.random() + '',
            })
          } else if (escape) {
            segs.push({
              type: 'escape',
              text: escape,
              key: Math.random() + '',
            })
          } else if (prefix) {
            segs.push({
              type: prefix === '@' ? 'local' : 'context',
              text: name || enclosed_name || '',
              enclosed_begin: enclosed_begin ? '{' : '',
              enclosed_end: enclosed_end ? '}' : '',
              key: Math.random() + '',
            })
          }
          return ''
        })
      return segs
    },
    // turns back into string
    toExpression (segs) {
      return segs.map((seg) => {
        if (seg.type === 'local') {
          return '@' + seg.enclosed_begin + seg.text + seg.enclosed_end
        } else if (seg.type === 'context') {
          return '$' + seg.enclosed_begin + seg.text + seg.enclosed_end
        } else return seg.text
      }).join('')
    },
    // look for @ and $ for new variables
    parseText ({ text, key }, methods) {
      text.replace(/([^$@]+)|(\$\$|@@)|([$@])(?:(\{)([A-Za-z_][A-Za-z_0-9]*)?(\})?|([A-Za-z_][A-Za-z_0-9]*)?)/g,
        (_, text, escape, prefix, enclosed_begin, enclosed_name, enclosed_end, name) => {
          if (text) {
            methods.push_text(text, key)
            key = null
          } else if (escape) {
            methods.push_seg({
              type: 'escape',
              text: escape,
              key: methods.get_key(),
            })
          } else if (prefix) {
            methods.push_seg({
              type: prefix === '@' ? 'local' : 'context',
              text: name || enclosed_name || '',
              enclosed_begin: enclosed_begin ? '{' : '',
              enclosed_end: enclosed_end ? '}' : '',
              key: methods.get_key(),
            })
          }
          return ''
        })
    },
    // Check for anything else than what is expected
    parseEscape (attrs, methods) {
      let m = attrs.text.match(/(.*)(\$\$|@@)(.*)/)
      if (!m) {
        methods.push_text(attrs.text)
        return
      }
      if (m[1]) methods.push_text(m[1])
      methods.push_seg({
        type: 'excape',
        text: m[2],
        key: attrs.key,
      })
      if (m[3]) methods.push_text(m[3])
    },
    // check that it is still looking like a variable
    parseVariable (attrs, methods) {
      let m = attrs.text.match(/([^$@]*)(?:\$\$|@@|([$@])(?:\{([A-Za-z_][A-Za-z_0-9]*)?(\})?|([A-Za-z_][A-Za-z_0-9]*)?))(.*)/)
      if (!m || m[2]) {
        methods.push_text(attrs.text)
        return
      }
      const [before, prefix, name, enclosed_name, enclosed_end, after] = m
      if (before) methods.push_text(before)
      methods.push_seg({
        type: prefix === '@' ? 'local' : 'context',
        text: name || enclosed_name || '',
        enclosed_begin: name ? '' : '{',
        enclosed_end: enclosed_end ? '}' : '',
        key: attrs.key,
      })
      if (after) methods.push_text(after)
    },
    parseLocal (attrs, methods) { return this.parseVariable(attrs, methods) },
    parseContext (attrs, methods) { return this.parseVariable(attrs, methods) },
    parseInvalid (attrs, methods) { methods.push_text(attrs.text) },
    // adds @ in front
    renderLocal (seg, el, attrs) {
      return el.text('@' + seg.enclosed_begin + seg.text + seg.enclosed_end).attr(attrs)
    },
    // adds $ in front
    renderContext (seg, el, attrs) {
      return el.text('$' + seg.enclosed_begin + seg.text + seg.enclosed_end).attr(attrs)
    },
    // calls to check for a new suggestion
    // input = true if it comes from a user input
    handleSuggestion (input) {
      let pos = this.position, suggestion = null
      if (!pos.key) return
      // a variable, suggestion using the current variable name as query
      // the suggestion should be placed under the variable
      if (pos.type === 'local' || pos.type === 'context') {
        const length = pos.text.length
        const begin = pos.text[1] === '{'
        const end = pos.text[length - 1] === '}'
        suggestion = {
          input: input,
          type: pos.type,
          query: pos.text.substr(1 + begin, length - 1 - begin - end),
          key: pos.key,
          x: pos.el && pos.el.offset().left + pos.el.width() / 2,
          y: (!this.multiline ? undefined : pos.el) &&
            pos.el.offset().top + pos.el.height(),
        }
      }
      // no suggestion for the cursor, close the suggestion
      if (!suggestion) this.suggestion = null
      // suggestion on input, open suggestions
      else if (input) this.suggestion = suggestion
      // no previous suggestion opened, keep suggestion for "down" pressed
      else if (!this.suggestion || !this.suggestion.input) {
        this.suggestion = suggestion
      // suggestion on a different variable, close and replace the current one
      } else if (suggestion.key !== this.suggestion.key ||
          suggestion.type === 'text' && suggestion.left !== this.suggestion.left) {
        this.suggestion = suggestion
      }
    },
    // inserts a variable name on a suggestion
    setVariable (query, value) {
      if (!query || !value) return
      let out = [], pos = this.position.key === query.key && this.position.absolute
      this.copySegments.forEach(seg => {
        if (query.key === seg.key) {
          if (seg.type !== 'text') {
            out.push({
              ...seg,
              enclosed_end: seg.enclosed_begin ? '}' : '',
              text: value,
            })
            if (pos) {
              pos += value.length + 1 + 2 * !!seg.enclosed_begin - this.position.left
            }
          } else {
            if (query.left > 1) {
              out.push({
                type: 'text',
                key: seg.key,
                text: seg.text.substr(0, query.left - 1),
              })
            }
            out.push({
              type: query.type,
              key: Math.random() + '',
              text: value,
            })
            if (query.left < seg.text.length) {
              out.push({
                type: 'text',
                key: seg.key,
                text: seg.text.substr(query.left),
              })
            }
            if (pos) {
              pos += query.left + value.length - this.position.left
            }
          }
        } else out.push(seg)
      })
      this.copySegments = out
      // rerender the contenteditable div
      this.renderHTML()
      this.setPosition(pos || this.position.absolute)
      // emit an event
      this.$emit('update:segments', this.copySegments)
      // update expression
      this.copyExpression = this.toExpression(this.copySegments)
    },
  },
}

export default {
  name: 'ElStringAutocomplete',
  extends: ElColorableAutocomplete,
  props: {
    input: {
      default: () => ElStringInput,
    },
  },
}
</script>

<style lang="scss">
  @import "../../element-variables.scss";

  /* style of response variables */
  .el-colorable__local {
    background-color: $entity-bg-color;
  }
  .el-colorable__context {
    background-color: $variable-bg-color;
  }
  .el-colorable__tuned {
    font-style: italic;
  }
  .el-colorable__invalid {
    font-style: italic;
    color: $--color-danger;
    // border-bottom: 2px dotted red;
  }
</style>
